import React from "react";
import {Typography, Box} from "@material-ui/core";
import {useHtmlComponentGql} from "../../../../hooks/useHtmlComponent";
import defaultTheme from "../../../../common/theme";
import PropTypes from "prop-types";
import CustomRichTextFromMarkdown from "../../../widget/text/CustomRichTextFromMarkdown";
import Skeleton from "@material-ui/lab/Skeleton";

const query = `
    elementsCollection {
        items {
            ... on TextColumnsWithImage{
                description
                title
                subtitle
                text
            }
        }
    }
`;

const TutorialStepTextPrice = ({componentId, price}) => {
    const {componentData, componentDataLoading} = useHtmlComponentGql(componentId, query);
    const items = componentData?.elementsCollection?.items;

    return (
        <>
            {!componentDataLoading ? (
                <Box
                    justifyContent={"center"}
                    flexWrap={"wrap"}
                    display={"flex"}
                >
                    <CustomRichTextFromMarkdown
                        markdownString={items[0]?.description}
                    />
                    <Box
                        display={"flex"}
                        alignItems={"center"}
                        flexDirection={"column"}
                        border={1}
                        borderRadius={80}
                        borderColor={defaultTheme.palette.borders.line.light}
                        my={2}
                        py={1}
                        px={3}
                    >
                        <Typography variant={"h3"}>
                            {price ? `EUR ${price}` : `EUR ${items[1]?.text}`}
                        </Typography>
                        {!price &&
                            <Typography variant={"caption"}>
                                {items[1]?.subtitle}
                            </Typography>
                        }
                    </Box>
                    <CustomRichTextFromMarkdown
                        markdownString={items[2]?.description}
                    />
                </Box>
            ) : (
                <Skeleton
                    variant="rect"
                    height={254}
                />
            )
            }
        </>
    );
};

TutorialStepTextPrice.propTypes = {
    componentId: PropTypes.any,
    price: PropTypes.string,
};

export default TutorialStepTextPrice;
